import React, { FunctionComponent } from 'react'

import { LightQuestionnaire } from '../../../../model/Questionnaire'

import { Tag } from '../../../shared'
import styles from './QuestionnaireListItem.module.scss'

export const QuestionnaireListItem: FunctionComponent<{
  item: LightQuestionnaire
}> = ({ item }) => {
  const label = item.private ? 'Privé' : 'Public'
  return (
    <div className={styles.questionnaireListItemContainer}>
      <Tag testId={`questionnaire-${item.private ? 'private' : 'public'}`}>{label}</Tag>
      {item.scoreConfig && <Tag testId="questionnaire-score">Score Scientifique</Tag>}
      <span>{item.title}</span>
    </div>
  )
}
